import type React from 'react'
import InformationCircleIcon from '../../../../../../assets/icons/information-circle-stroke-rounded'
import Tooltip from '../../../../../../components/Tooltip'

interface MetricCardProps {
  title: string
  value: string
  previousValue?: number | null
  percentageChange?: number | null
  description?: string
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  previousValue,
  percentageChange,
  description,
}) => {
  const getChangeColor = () => {
    if (!percentageChange) return 'text-gray-500'
    if (percentageChange > 0) return 'text-green-600'
    if (percentageChange < 0) return 'text-red-600'
    return 'text-gray-500'
  }

  const formatPercentage = (val?: number | null) => {
    if (val === null || val === undefined) return 'N/A'
    return `${val > 0 ? '+' : ''}${val.toFixed(2)}%`
  }

  return (
    <div className="bg-white shadow-sm p-6 rounded-2xl border-solid border-[1px] border-black/10">
      <div className="flex items-center gap-2 mb-2">
        <p className="text-sm text-gray-600">{title}</p>
        {description && (
          <Tooltip
            label={
              <div className="whitespace-pre-line text-sm">{description}</div>
            }
            placement="top"
            maxWidth={400}
          >
            <InformationCircleIcon
              className="w-4 h-4 text-gray-400 cursor-help"
              hideTitle={true}
            />
          </Tooltip>
        )}
      </div>
      <p className="text-2xl font-semibold mb-2">{value}</p>
      {percentageChange !== null && percentageChange !== undefined && (
        <div className="flex items-center gap-2">
          <p className={`text-sm font-medium ${getChangeColor()}`}>
            {formatPercentage(percentageChange)}
          </p>
          {previousValue !== null && previousValue !== undefined && (
            <p className="text-xs text-gray-500">
              Previous: {previousValue.toFixed(2)}
            </p>
          )}
        </div>
      )}
    </div>
  )
}

export default MetricCard
